import axios from 'axios'
import { API_ROUTES } from '../routes'

export const getEmployeeCost = () => {
  return axios.get(API_ROUTES.EMPLOYEE_COST)
}
